import React from "react";
import { LayoutMain } from "@unisearch/theme/layout";
import {
  ElearningLeadHero,
  ElearningLeadHighlights,
  ElearningLeadForm,
} from "@modules/elearning/lead";

const Lead = () => {
  return (
    <LayoutMain
      title="Band 9 IELTS Speaking"
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/elearning/band-9-IELTS-speaking`}
    >
      <ElearningLeadHero />
      <ElearningLeadHighlights />
      <ElearningLeadForm />
    </LayoutMain>
  );
};

export default Lead;
